import classNames from "classnames";

const svgPaths = {
  circle: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
  pinBody: "M30 29.74C30 35.02 27.27 39.66 23.15 42.33C23.13 42.34 23.12 42.35 23.1 42.36C20.19 44.49 15 46.41 15 59.48C15 46.41 9.81 44.49 6.9 42.36C6.88 42.36 6.87 42.34 6.85 42.33C2.73 39.66 0 35.02 0 29.74C0 24.46 2.73 19.82 6.85 17.15C6.87 17.14 6.88 17.13 6.9 17.12C9.81 14.99 15 13.07 15 0C15 13.07 20.19 14.99 23.1 17.12C23.12 17.13 23.13 17.14 23.15 17.15C27.27 19.82 30 24.46 30 29.74Z",
  chevron: "M3.35 8.19L0 4.09L3.35 0L4.62 1.04L2.12 4.09L4.62 7.14L3.35 8.19Z",
};

interface DrawerButtonProps {
  isCollapsed?: boolean;
  className?: string;
}

export default function DrawerButton({ isCollapsed = false, className }: DrawerButtonProps) {
  return (
    <div className={classNames("relative w-[30px] h-[60px] group", className)} data-name="drawer_button">
      <div className="absolute inset-0 overflow-clip">
        {/* Pin body shape */}
        <div className="absolute bottom-[0.87%] left-0 right-0 top-0">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 30 60">
            <path d={svgPaths.pinBody} fill="#202936" />
          </svg>
        </div>
        {/* Inner circle - highlights on hover */}
        <div className="absolute inset-[29%_12%_30%_12%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
            <path 
              d={svgPaths.circle} 
              className="fill-[#293444] group-hover:fill-[#3a4a5e] transition-[fill] duration-200" 
            />
          </svg>
        </div>
        {/* Chevron arrow - brightens on hover */}
        <div className="absolute inset-[38%_38%_39%_38%]">
          <svg 
            className={classNames(
              "block size-full transition-transform duration-300",
              { "rotate-180": !isCollapsed }
            )} 
            fill="none" 
            preserveAspectRatio="none" 
            viewBox="0 0 5 9"
          >
            <path 
              d={svgPaths.chevron} 
              className="fill-[#98ABC9] group-hover:fill-white transition-[fill] duration-200" 
            />
          </svg>
        </div>
      </div>
    </div>
  );
}

